import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["fields"]

  reveal(event) {
    event.preventDefault()
    this.fieldsTarget.classList.remove("hidden")
    event.currentTarget.classList.add("hidden")
  }
}
